import * as tslib_1 from "tslib";
import * as React from 'react';
import { DefaultButton } from '../DefaultButton/DefaultButton';
import { BaseComponent, customizable, nullRender } from '../../../Utilities';
import { getStyles } from './MessageBarButton.styles';
/**
 * {@docCategory MessageBar}
 */
var MessageBarButton = /** @class */ (function (_super) {
    tslib_1.__extends(MessageBarButton, _super);
    function MessageBarButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MessageBarButton.prototype.render = function () {
        var _a = this.props, styles = _a.styles, theme = _a.theme;
        return React.createElement(DefaultButton, tslib_1.__assign({}, this.props, { styles: getStyles(theme, styles), onRenderDescription: nullRender }));
    };
    MessageBarButton = tslib_1.__decorate([
        customizable('MessageBarButton', ['theme', 'styles'], true)
    ], MessageBarButton);
    return MessageBarButton;
}(BaseComponent));
export { MessageBarButton };
//# sourceMappingURL=MessageBarButton.js.map